require('./aggregatorCredentialsView.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const { withRouter } = require('react-router-dom');

// @components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import { AggregatorAddEntityStepLogin } from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityStepLogin/aggregatorAddEntityStepLogin'
import { OKButton } from 'commonsComponents/OKButton';
import { OKLink } from 'commonsComponents/OKLink';
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';
import WizardError from 'components/commons/wizardError/wizardError';

// @actions
import {
    getDataBank,
    setFormValue,
    sendFormInfo,
    clearAddEntity,
    clearFormValues
} from 'actions/aggregator/aggregatorAddEntity'

// @utilities
import { isFormFilled } from 'utilities/aggregator/aggregatorFormHelper'
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { AGGREGATOR_NEW_FEATURES } = require('constants/flagBasedFeatures');

class AggregatorCredentialsViewClass extends React.PureComponent {

    constructor(props) {
        super(props);
        this.renderError = this.renderError.bind(this);
    }

    componentDidMount() {
        const { bank, history } = this.props
        !bank && history.push("/myprofile/global")
    }

    componentWillUnmount() {
        this.props.clearAddEntity()
    }

    getMappingBreadcrumb() {
        return [{
            text: formatText('breadcrumb-global'),
            url: '/myprofile/global'
        },
        {
            text: formatText('breadcrumb-aggregatorSettingsPG'),
            url: '/myprofile/global/entities/manage'
        }, {
            text: formatText('breadcrumb-credentials'),
            url: ''
        }]
    }

    handleOnAccept = () => {
        const { sendFormInfo, immAggregatorAddEntity, bank } = this.props

        const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1])

        sendFormInfo(immLoginStep.get('publicKey'), immLoginStep.get('code'), immAggregatorAddEntity.get('values'), bank.get('userBankId'))
    }

    renderError() {
        const errorTitle = formatText('aggregatorAddEntity-errorTitle')
        const errorMessage = formatText('aggregatorAddEntity-errorMessage')
        const onClickFunc = () => {
            this.props.history.push('/myprofile/global')
        }

        const mainButton = {
            label: formatText("aggregatorAddEntity-backToGlobalPosition")
        }

        return (
            <WizardError
                errorMessage={errorTitle}
                customClassName="aggregator-credentials-view__wizard__wizard-step-login__form__form__wizard-error"
                mainButton={mainButton}
                onMainButtonClick={onClickFunc}
            >
                <p>{errorMessage}</p>
            </WizardError>
        )
    }

    renderSuccesful() {
        const { bank, history } = this.props;
        const { imageUrl } = bank ? bank.toJS() : {}
        const successMessage = formatText(`aggregatorCredentialsSuccess-title`);
        const mainButton = {
            label: (<FormattedText value={`aggregatorCredentialsSuccess-button`} />)
        };

        return (
            <div className="aggregator-credentials-view__confirm-success-step col-xs-12">
                <WizardSuccess
                    successMessage={successMessage}
                    mainButton={mainButton}
                    onMainButtonClick={() => history.push("/myprofile/global")}
                >
                    <p>
                        <FormattedText value="aggregatorCredentialsSuccess-text" />
                    </p>
                    <img className="aggregator-credentials-view__confirm-success-step__img" src={imageUrl} />
                </WizardSuccess>
            </div>
        );
    }

    renderContent() {
        const { immAggregatorAddEntity, immFlagBasedFeatures, bank, getDataBank, setFormValue, clearFormValues } = this.props
        const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1])
        const AGGREGATOR_V2 = immFlagBasedFeatures.get(AGGREGATOR_NEW_FEATURES)

        if (immAggregatorAddEntity.get('error'))
            return this.renderError()

        if (immAggregatorAddEntity.get('submitSuccessful'))
            return this.renderSuccesful()

        const formButtonEnabled = isFormFilled(immLoginStep.get('form'), immAggregatorAddEntity.get('values'));

        return (
            <div className="aggregator-credentials-view">
                <AggregatorAddEntityStepLogin
                    getDataBank={getDataBank}
                    form={immLoginStep.get('form')}
                    beta={immLoginStep.get('beta')}
                    setFormValue={setFormValue}
                    clearFormValues={clearFormValues}
                    bankId={bank && (AGGREGATOR_V2 ? bank.get('code') : bank.get('robotName'))}
                    bankUniqueId={bank && (AGGREGATOR_V2 ? bank.get('code') : bank.get('robotName'))}
                    bankCode={bank && bank.get('code')}
                    name={bank && bank.get('name')}
                    url={bank && bank.get('imageUrl')}
                    isFetching={immLoginStep.get('isFetching')}
                    values={immAggregatorAddEntity.get('values')}
                    submitFetching={immLoginStep.get('fetchingform')}
                    showDisclaimer={false}
                    mustLoadBankData={true}
                />
                <footer className="aggregator-credentials-view__buttons row">
                    <div className="aggregator-credentials-view__buttons__left col-xs-6">
                        <OKLink
                            modifier="emphasize"
                            to="/myprofile/global/entities/manage"
                        >
                            <FormattedText value="aggregatorCredentials-back" />
                        </OKLink>
                    </div>
                    <div className="aggregator-credentials-view__buttons__right col-xs-6">
                        <OKButton
                            modifier="primary"
                            onClick={this.handleOnAccept}
                            disabled={!formButtonEnabled}
                        >
                            <FormattedText value="aggregatorCredentials-accept" />
                        </OKButton>
                    </div>
                </footer>
            </div>
        )
    }

    render() {
        return (
            <AggregatorAddEntityLayout
                title={formatText('aggregatorCredentials-title')}
                breadCrumb={this.getMappingBreadcrumb()}
                showInfoColumn={true}
            >
                {this.renderContent()}
            </AggregatorAddEntityLayout>
        )
    }
}

AggregatorCredentialsViewClass.propTypes = {
    history: PropTypes.object.isRequired,
    immAggregatorAddEntity: PropTypes.object,
    bank: PropTypes.object,
    clearAddEntity: PropTypes.func,
    getDataBank: PropTypes.func,
    sendFormInfo: PropTypes.func,
    setFormValue: PropTypes.func,
    clearFormValues: PropTypes.func,
    match: PropTypes.shape({
        params: PropTypes.shape({
            bankId: PropTypes.string
        }),
    }),
    immFlagBasedFeatures: PropTypes.object
}

const AggregatorCredentialsView = withRouter(connect(
    (state, ownProps) => ({
        immAggregatorAddEntity: state.aggregatorAddEntity,
        immFlagBasedFeatures: state.flagBasedFeatures,
        bank: state.aggregatorData.getIn(['data', 'banks', ownProps.match.params.bankId])
    }), {
    sendFormInfo,
    getDataBank,
    setFormValue,
    clearAddEntity,
    clearFormValues
}
)(AggregatorCredentialsViewClass))

module.exports.constructor = AggregatorCredentialsView;
module.exports.AggregatorCredentialsView = AggregatorCredentialsView
